import { Outlet } from 'react-router-dom';
import SharedNavbar from './SharedNavbar';
import Footer from '../../pages/home/components/Footer';

export default function Layout() {
  return (
    <div className="w-full min-h-screen overflow-x-hidden flex flex-col">
      <SharedNavbar />
      <main className="w-full overflow-x-hidden flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
